import { Button, ButtonProps, BoxProps, styled } from '@mui/material';

export const LayerButton = styled(Button, {
  shouldForwardProp: (prop: string) => !['active'].includes(prop),
})<{
  active?: boolean;
}>`
  display: flex;
  flex-shrink: 0;
  font-weight: normal;
  border-radius: 22px;
  color: ${({ active }) => (active ? '#0494FE' : 'grey.800')};
  border: 1px solid ${({ active }) => (active ? '#0494FE' : '#d0d5dd')};
  height: 44px;
  padding: 10px 16px;

  background: ${({ active }) => (active ? 'rgba(4, 148, 254, 0.06)' : '#fff')};
  &:hover {
    background: ${({ active }) => (active ? 'rgba(4, 148, 254, 0.06)' : '#fff')};
  }
  & svg {
    width: 20px;
    height: 20px;
    margin-inline-end: 5px;
    stroke: currentColor;
  }
` as React.ComponentType<ButtonProps & { active?: boolean }>;

export const CenterDiv = styled('div')`
  position: relative;
  bottom: 20px;
  padding: 8px;
  border-radius: 12px;
  border: 1px solid #eaecf0;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

  ::before {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid white;
  }
` as React.ComponentType<BoxProps>;
